<template lang='pug'>
v-form(ref='purchaseCarnetFormReservation' @submit.prevent)
	stations-fields(@select-station="setStation")
	div.tw-flex.tw-items-center.tw-gap-2(class="emd:tw-flex-col emd:tw-gap-1")
		v-select(
			v-model="bookingStore.carnet.selectedCarnetId"
			:items="bookingStore.carnet.list"
			item-title="displayName"
			item-value="id"
			:label="$t('form_labels.purchase_carnet.type', 'Tipologia Carnet')"
			:loading="carnetLoading"
			required
			class="emd:tw-w-full"
		)
		v-text-field(
			:model-value="bookingStore.searchFilters.startDate && bookingStore.searchFilters.startDate.toLocaleDateString()"
			readonly
			:label="$t('form_labels.purchase_carnet.valid_from', 'Valido dal')"
			disabled
			class="emd:tw-w-full"
		)
</template>


<script setup>
import {inject, ref} from 'vue';
import { useBookingStore } from '@/stores/booking';
import { useBookingStepperStore } from '@/stores/booking-stepper';
import StationsFields from "@/sale/components/tab1_search/stations-fields.vue";
import { onMounted } from 'vue';
import {useI18n} from "vue-i18n";



const stepper = useBookingStepperStore();
const bookingStore = useBookingStore();
const axios = inject('axios');
const carnetLoading = ref(false);
const purchaseCarnetFormReservation = ref(null);
const i18n = useI18n();

function setStation(station) {
	bookingStore.searchFilters[station.target + 'Station'] = station.val;
}

function loadCarnetList(){
	carnetLoading.value = true;
	const savedCarnets = sessionStorage.getItem('carnet-list');
	if(savedCarnets){
		bookingStore.carnet.list = JSON.parse(savedCarnets);
		bookingStore.carnet.selectedCarnetId = bookingStore.carnet.list[0].id;
		carnetLoading.value = false;
	}else{
		axios.get('trenitalia/carnet-list')
		.then(res => {
			bookingStore.carnet.list = res.data;
			bookingStore.carnet.selectedCarnetId = bookingStore.carnet.list[0].id;
			sessionStorage.setItem('carnet-list', JSON.stringify(bookingStore.carnet.list));
		}).catch(() => {})
		.finally(() => {
			carnetLoading.value = false;
		});
	}
}

onMounted(() => {
	if (stepper.step == 'search' && 'carnet' == stepper.bookingType) {
		loadCarnetList();
	}
});

defineExpose({
	purchaseCarnetFormReservation
});
</script>

<style>
</style>